import ApiClientInstance from '../../common/ApiClient';
import { ISO_DATE_FORMAT } from '../../utils/formatters';

export const apiRequestCSV = (companyId, accountId, format, { start, end }) => (
  ApiClientInstance.post(`api/accountants/company/transactions/${accountId}/csv?date_start=${start.format(ISO_DATE_FORMAT)}&date_end=${end.format(ISO_DATE_FORMAT)}&csv_format=${format}${companyId ? `&company_id=${companyId}` : ''}`)
);

export const apiRequestCSVCheckStatus = (companyId, accountId, taskId) => (
  ApiClientInstance.get(
    `api/accountants/company/transactions/${accountId}/csv/${taskId}${companyId ? `?company_id=${companyId}` : ''}`,
  )
);

export const apiGetCSV = (companyId, id) => ApiClientInstance.get(
  `api/accountants/company/media/${id}${companyId ? `?company_id=${companyId}` : ''}`,
  {
    'Content-Type': 'text/csv',
  },
);
